/*
 * 企業側 ファイル共有 一覧取得
 */
import { apiGetList } from '@/actions/ApiBaseActions';
export const API_GET_LIST_CLIENT_SHARE_DOCUMENT_ALL = 'API_GET_LIST_CLIENT_SHARE_DOCUMENT_ALL';
export const API_GET_LIST_CLIENT_SHARE_DOCUMENT_ONE_SHARED_DOCUMENT = 'API_GET_LIST_CLIENT_SHARE_DOCUMENT_ONE_SHARED_DOCUMENT';
export const API_GET_LIST_CLIENT_SHARE_DOCUMENT_ONE_MESSAGE = 'API_GET_LIST_CLIENT_SHARE_DOCUMENT_ONE_MESSAGE';
/**
 * ファイル共有 一括送付用の閲覧申請一覧取得
 */
export const apiGetListClientRfpShareDocumentAll = ({ path: { id } }, meta) => apiGetList(API_GET_LIST_CLIENT_SHARE_DOCUMENT_ALL, `/client/rfp/${id}/share_document_all`, {}, Object.assign(Object.assign({}, meta), { isSnakeCase: true, requestPayload: { id } }));
/**
 * ファイル共有 個別送付の共有済み閲覧申請一覧取得
 */
export const apiGetListClientRfpShareDocumentOneViewRequest = ({ path: { id } }, meta) => apiGetList(API_GET_LIST_CLIENT_SHARE_DOCUMENT_ONE_SHARED_DOCUMENT, `/client/rfp/${id}/share_document`, {}, Object.assign(Object.assign({}, meta), { isSnakeCase: true }));
/**
 * ファイル共有 個別送付の共有済みメッセージ一覧取得
 */
export const apiGetListClientRfpShareDocumentOneMessage = ({ path: { id, view_request_id: viewRequestId } }, meta) => apiGetList(API_GET_LIST_CLIENT_SHARE_DOCUMENT_ONE_MESSAGE, `/client/rfp/${id}/share_document/${viewRequestId}`, {}, Object.assign(Object.assign({}, meta), { isSnakeCase: true }));
